import Settings from '../olr-common/Settings';

export default function OauthService($http,localStorageService) {
  var nonce = 'EXM^s1;e)zK';
  localStorageService.set('nonce', nonce);
  this.redirectToGoogle = function(){

    let queryParams = "response_type=" + Settings.oauth.responseType + "&scope=email%20profile&client_id="+Settings.oauth.client_id+"&"+
      "redirect_uri=" + Settings.oauth.redirectUrl + "&" +
      "access_type=" + Settings.oauth.accessType + "&" +
      "nonce=" + 'EXM^s1;e)zK' + "&" +
      "prompt=" + Settings.oauth.prompt + "&" +
      "state=" + Settings.oauth.state + "&" +
      "include_granted_scopes=" + Settings.oauth.includeGrantedScopes;

    let redirectUrl = Settings.oauth.endpointUrl + "?" + queryParams;


    return redirectUrl;
  };

  this.getTokenFromGResp = function(code){
    let parms = "grant_type=" + Settings.token.grantType + "&" +
      "code=" + code + "&" +
      "client_id=" + Settings.oauth.client_id + "&" +
      "client_secret=" + Settings.token.client_secret + "&" +
      "redirect_uri=" + Settings.oauth.redirectUrl;

    return $http.post("https://www.googleapis.com/oauth2/v3/token", parms, {headers: {"Content-Type": "application/x-www-form-urlencoded"}});
  };

  this.getUserInfo = function(token) {
    console.log(token);
    let url = `${Settings.oauth.userUrl}/userinfo`;
    let headers= {};
    headers.Authorization = "Bearer " + token;
    
    return $http.get(url, {headers: {"Authorization": "Bearer "+token}});
  };
}


/** WEBPACK FOOTER **
 ** ./src/olr-mainfe-oauth2/OauthService.js
 **/